// extracted by mini-css-extract-plugin
export var avatarContainer = "_6i-0";
export var avatarTypingWave = "_6i-i";
export var gray = "_6i-f";
export var green = "_6i-c";
export var icon = "_6i-9";
export var image = "_6i-1";
export var lg = "_6i-6";
export var md = "_6i-5";
export var presenceDot = "_6i-b";
export var red = "_6i-d";
export var sm = "_6i-4";
export var status = "_6i-a";
export var typingDot = "_6i-h";
export var typingPill = "_6i-g";
export var xl = "_6i-7";
export var xs = "_6i-3";
export var xxl = "_6i-8";
export var xxs = "_6i-2";
export var yellow = "_6i-e";